import { useState, useEffect } from "react";

const Progress = ({ loading }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (loading) {
      setProgress(10);
      const interval = setInterval(() => {
        setProgress((prev) => (prev < 90 ? prev + 10 : prev));
      }, 500);
      return () => clearInterval(interval);
    } else {
      setProgress(100);
      setTimeout(() => setProgress(0), 500);
    }
  }, [loading]);

  return (
    <div
      className="invite-progress-bar-container"
      style={{ opacity: progress > 0 ? 1 : 0 }}
    >
      <div
        className="invite-progress-bar"
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  );
};

export default Progress;
